import gql from 'graphql-tag';

export const integrationItemKindFacetFragment = gql`
  fragment integrationItemKindFacetFragment on IntegrationItemKindFacet {
    dokkioClass
    integrationItemKind
    count
  }
`;
export default integrationItemKindFacetFragment;
